import { useRouter } from 'react-resource-router';

import SettingsIframe from 'src/sections/repository/sections/admin/containers/settings-iframe';

export const IframeWrapped = () => {
  const [router] = useRouter();

  return <SettingsIframe url={router.match.url} />;
};

export default IframeWrapped;
